import { Tabs } from "antd";
import { observer } from "mobx-react";
import { useNavigate, useLocation } from "react-router-dom";
import { __ } from "../../utils";
import { AccountAffiliateLayout, AccountDetailsForm, AccountInvoicesTable, AccountMagicLinkForm, AccountSubscriptionsTable } from ".";
import { useStores } from "../../store";
const AccountTabs = observer(() => {
  const navigate = useNavigate();
  const [, tab] = useLocation().pathname.split("/");
  const {
    accountStore: {
      isAffiliate,
      isLoggedIn
    }
  } = useStores();
  return !isLoggedIn ? /*#__PURE__*/React.createElement(AccountMagicLinkForm, null) : /*#__PURE__*/React.createElement(Tabs, {
    activeKey: tab,
    onTabClick: key => {
      navigate(`/${key}`);
    },
    tabBarStyle: {
      marginBottom: 0
    },
    items: [{
      key: "",
      label: __("Subscriptions and Licenses"),
      children: /*#__PURE__*/React.createElement(AccountSubscriptionsTable, null)
    }, {
      key: "invoices",
      label: __("Invoices"),
      children: /*#__PURE__*/React.createElement(AccountInvoicesTable, null)
    }, {
      key: "details",
      label: __("Account details"),
      children: /*#__PURE__*/React.createElement(AccountDetailsForm, null)
    }, {
      key: "affiliate",
      label: __("Affiliate"),
      className: isAffiliate ? `${process.env.ANTD_PREFIX}-tabs-tabpane-no-margin` : "",
      children: /*#__PURE__*/React.createElement(AccountAffiliateLayout, null)
    }]
  });
});
export { AccountTabs };